
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[param]/[month]",
      function () {
        return require("private-next-pages/sitemap/[param]/[month]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[param]/[month]"])
      });
    }
  